<template lang="pug">
  #contract-neo-order
    template(v-if="isLoading === true")
      loading
    template(v-else)
      .d-flex
        b-card.mt-1.flex-grow-1(header-tag="header")
          b-form-text.my-2.align-left.text-left.error-message-color(v-for="(message) of error_msg_list.upper_part_error.error_msg") {{message}}
          contract-neo-form(:error_msg_list="error_msg_list", v-model="value", @method="toggleNextButtonDisabled")
          b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", :to="{name: 'ApplyPlan'}")
            .float-right.search_message.ml-1.font-weight-bold 戻る
            b-icon.float-left.next-icon(icon="arrow-left-circle")
          b-button.float-right.mr-5.my-3(pill, :variant="nextButtonDisabled ? 'outline-secondary' : 'outline-primary'", size="lg", :disabled="nextButtonDisabled", @click="contractOrderView")
            .float-left.search_message.mr-1.font-weight-bold 次へ
            b-icon.float-right.next-icon(icon="arrow-right-circle")
        price-board(v-model="value")
</template>

<script>
/* eslint-disable */
import ContractNeoForm from "@/components/contractOrder/ContractNeoForm";
import PriceBoard from "@/components/PriceBoard";
import Loading from "@/components/Loading";

import Api from '@/repositories/api';
const C206ContractInfo = Api.get('c206ContractInfo');
const S203NeoContractOrder = Api.get('s203NeoContractOrder');

export default {
  name: "ContractNeoOrder",
  props: {
    value: { type: Object, required: false }
  },
  components: {
    ContractNeoForm,
    Loading,
    PriceBoard,
  },
  data() {
    return {
      nextButtonDisabled: true,
      error_msg_list: {
        // 画面上部のエラーメッセージ
        upper_part_error: {
          error_msg: []
        },
        // プラン
        plan: {
          error_msg: []
        },
        // 業務アプリ作成ツールAppSuite
        app_suite: {
          error_msg: []
        },
        // desknet's ウェブ会議
        web_conferencing: {
          error_msg: []
        },
        // オプションサービスチェックボックス
        option_service: {
          error_msg: []
        },
        // RoomMgrチェックボックス
        option_room_mgr: {
          error_msg: []
        },
        // 交通費・経費精算チェックボックス
        option_expense_settlement: {
          error_msg: []
        },
        // タイムカード＋CLOUZAチェックボックス
        clouza_check: {
          error_msg: []
        },
        // タイムカード＋CLOUZAユーザー数
        clouza_input: {
          error_msg: []
        },
        // タイムカード＋CLOUZA会社コード
        clouza_company_code: {
          error_msg: []
        },
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        paid_leave_option: {
          error_msg: []
        },
        // ディスク増設容量
        option_disk_size: {
          error_msg: []
        },
        // Sync for smartphoneチェックボックス
        option_sync: {
          error_msg: []
        },
        // Sync for smartphoneユーザー数
        option_sync_input: {
          error_msg: []
        },
        // desknet'sドライブ ディスク増設容量
        option_dn_drive_disk_size: {
          error_msg: []
        },
        // セキュリティオプションチェックボックス
        security_option: {
          error_msg: []
        },
        // BASIC認証チェックボックス
        basic_auth: {
          error_msg: []
        },
        // BASIC認証ユーザーID
        basic_auth_user: {
          error_msg: []
        },
        // BASIC認証パスワード
        basic_auth_password: {
          error_msg: []
        },
        // BASIC認証認証を除外するIPアドレス
        basic_auth_ip: {
          error_msg: []
        },
        // 接続元IPアドレス制限チェックボックス
        ip_restrictions: {
          error_msg: []
        },
        // 接続元IPアドレス制限接続を許可するIPアドレス
        ip_restrictions_ip: {
          error_msg: []
        },
        // セキュアブラウザチェックボックス
        secure_browser: {
          error_msg: []
        },
        // セキュアブラウザ端末認証
        secure_browser_terminal: {
          error_msg: []
        },
        // セキュアブラウザデバイス数
        secure_browser_device: {
          error_msg: []
        },
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        secure_browser_ip: {
          error_msg: []
        },
        // クライアント認証チェックボックス
        client_auth: {
          error_msg: []
        },
        // クライアント認証デバイス数
        client_auth_input: {
          error_msg: []
        },
        // クライアント認証認証を除外するIPアドレス
        client_auth_ip: {
          error_msg: []
        },
        // メールサービスチェックボックス
        mail_service: {
          error_msg: []
        },
        // WebARENA
        web_arena: {
          error_msg: []
        },
        // WebARENA利用ドメイン名
        web_arena_domain: {
          error_msg: []
        },
        // WebARENAアカウント数
        web_arena_input: {
          error_msg: []
        },
        // CYBERMAILΣチェックボックス
        cyber: {
          error_msg: []
        },
        // CYBERMAILΣアカウント数
        cyber_input: {
          error_msg: []
        },
        // CYBERMAILΣメールボックス容量
        cyber_capacity: {
          error_msg: []
        },
        // CYBERMAILΣオプション
        cyber_option: {
          error_msg: []
        },
        // CYBERMAILΣ保存期間
        cyber_keep_period: {
          error_msg: []
        },
        // メールセキュリティサービスチェックボックス
        mail_security_service: {
          error_msg: []
        },
        // MAILGATES Σチェックボックス
        mailgates: {
          error_msg: []
        },
        // WebARENA利用ドメイン名
        mailgates_domain: {
          error_msg: []
        },
        // MAILGATES Σアカウント数
        mailgates_input: {
          error_msg: []
        },
        // MAILGATES Σオプション
        mailgates_option: {
          error_msg: []
        },
        // ご希望サブドメイン名
        sub_domain: {
          error_msg: [],
        },
        // 無料お試し版からのデータ移行チェックボックス
        migration: {
          error_msg: []
        },
        // 無料お試し版からのデータ移行試使用環境URL
        migration_url: {
          error_msg: []
        },
        // 無料お試し版からのデータ移行作業日付
        // 無料お試し版からのデータ移行作業時刻（から）
        // 無料お試し版からのデータ移行作業時刻（まで）
        migration_datetime: {
          error_msg: []
        },
        // ご利用開始希望日
        preferred_date: {
          error_msg: []
        },
        // お見積番号
        estimate: {
          error_msg: []
        },
        // 備考
        remarks: {
          error_msg: []
        },
        // サービス利用約款などチェックボックス
        provision_check: {
          error_msg: []
        }
      },

      // エラー発生時のスクロール先
      errorHash: '',

      // ローディングフラグ
      isLoading: false,
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // 既に契約番号が入力されている場合
    if (this.value.contract_no) {
      // 権限チェックを実行
      this.validateAuthority()
    }
    // 画面パラメータに契約番号が存在する場合
    else if ('contract_no' in this.$route.params) {
      // 権限チェックを実行
      this.validateAuthority()
      // 契約番号を設定
      this.value.contract_no = this.$route.params.contract_no
    }
    // 画面パラメータに契約番号が存在しない場合
    else {
      // C20601_契約情報取得処理を実行
      C206ContractInfo.get({contract_class: '6'})
        .then((response) => {
          // 取得した契約情報数が1件の場合
          if (response.data.data.length === 1) {
            // 権限チェックを実行
            this.validateAuthority()
            // 契約番号を設定
            this.value.contract_no = response.data.data[0].contract_no
          }
          else {
            // セッションストレージにデータを保存
            sessionStorage.setItem('contract_class', '6')
            sessionStorage.setItem('previous', 'ContractNeoOrder')

            // S11500_ご契約環境選択画面に遷移
            this.$router.push({ name: 'ContractSelect' })
          }
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '画面表示処理', "Support")

          // 画面TOPまでスクロールをする
          this.pageTopScroll()
        })
    }

    // 選択したプランを取得
    this.value.plan_name = localStorage.getItem('plan_name')

    // サービス利用規約がチェックされている場合、「次へ」ボタンを有効にする
    if (this.value.provision_check === true) {
      this.toggleNextButtonDisabled()
    }
  },
  methods: {
    /**
     * 権限チェックを行う
     */
    validateAuthority() {
      // 権限チェックを行う
      S203NeoContractOrder.view()
        .catch((err) => {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // アプリケーションエラー画面へ遷移する
            this.$router.push({
              name: 'SupportApplicationError',
              params: {
                // 画面に表示するエラーメッセージ
                error_msg: this.forbidden_message
              }
            })
          }
        })
        .finally(() => {
          // 読み込み完了
          this.isLoading = false
        })
    },
    contractOrderView() {
      // エラー表示をリセットする
      this.resetError()
      // 入力のある項目を送信する前準備
      let submitData = this.createRequestData()

      // 次へボタンをロックする
      this.nextButtonDisabled = true;

      // API実行
      S203NeoContractOrder.check(submitData)
      .then((response) => {
        // 入力内容のエラーが無い場合
        if (response.data.success === true) {
          // 大項目がチェックされていない場合、直下のチェックボックスのチェックを外す
          this.uncheckChildren()

          // 請求単位を設定する
          this.value.contract_type = Number(response.data.contract_type)

          // desknet's NEO ご契約お申し込み内容確認画面に移動
          this.$router.push({
            name: "ContractNeoConfirm"
          })
        }
      })
      .catch((err) => {
        // 次へボタンをロックを解除する
        this.nextButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(err, '入力チェック処理', 'ContractChat')

        // httpステータスコードが403の場合（権限エラー）
        if (err.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.upper_part_error.error_msg.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // エラーメッセージがある場合
        if (err.response.data.error_list !== null && err.response.data.error_list !== undefined) {
          // エラー要素の取得
          const errList = err.response.data.error_list
          // 各要素のエラーメッセージを出力する
          errList.forEach((objErr) => {
            let target = objErr.target
            let errorMsg = objErr.error_msg

            // targetが未定義である場合
            if (typeof target === 'undefined') {
              // 画面上部にエラーメッセージを表示する
              this.error_msg_list.upper_part_error.error_msg.push(errorMsg)

              // 画面一番上へスクロールする
              this.pageTopScroll();
            }
            else {
              // 対象の項目にエラーメッセージセット・スクロール先設定
              this.responseErrorMessage(target, errorMsg)
            }
          })
        }

        // エラーが発生した項目までスクロールする
        this.scrollToAnchor(this.errorHash)
      })
    },
    // 大項目がチェックされていない場合、直下のチェックボックスのチェックを外す
    uncheckChildren() {
      // NEO オプションサービス
      if (this.value.option_service === false) {
        this.value.option_expense_settlement = false
        this.value.clouza_check = false
        this.value.option_disk = false
        this.value.option_sync = false
        this.value.option_dn_drive = false
      }
      // NEO セキュリティオプション
      if (this.value.security_option === false) {
        this.value.basic_auth = false
        this.value.ip_restrictions = false
        this.value.secure_browser = false
        this.value.client_auth = false
      }
      // NEO メールサービス
      if (this.value.mail_service === false) {
        this.value.web_arena = false
        this.value.cyber = false
      }
      // NEO メールサービス
      if (this.value.mail_security_service === false) {
        this.value.mailgates = false
      }
    },
    createRequestData() {
      // 入力内容を格納するオブジェクトを作成
      let requestData = {}
      // 契約番号
      requestData.contract_no = this.value.contract_no
      // プラン名
      if (this.value.plan_name !== null && this.value.plan_name !== '') {
        requestData.plan_name = this.value.plan_name
      }
      // プランユーザー数
      if (this.value.plan_user !== null && this.value.plan_user !== '') {
        requestData.plan_user = this.value.plan_user
      }
      // 業務アプリ作成ツールAppSuite
      if (this.value.app_suite_user !== null && this.value.app_suite_user !== '') {
        requestData.app_suite_user = this.value.app_suite_user
      }
      // desknet's ウェブ会議
      if (this.value.web_conferencing !== null && this.value.web_conferencing !== '') {
        requestData.web_conferencing = this.value.web_conferencing
      }
      // オプションサービス チェックボックス
      if (this.value.option_service === true) {
        requestData.option_service = '1'
      }
      // RoomMgr
      if (this.value.option_room_mgr === true) {
        requestData.option_room_mgr = '1'
      }
      // 交通費・経費精算チェックボックス
      if (this.value.option_expense_settlement === true) {
        requestData.option_expense_settlement = '1'
      }
      // タイムカード＋CLOUZA
      if (this.value.clouza_check === true) {
        requestData.clouza_check = '1'
      }
      // タイムカード＋CLOUZAユーザー数
      if (this.value.clouza_input !== null && this.value.clouza_input !== '') {
        requestData.clouza_input = this.value.clouza_input
      }
      // タイムカード＋CLOUZA会社コード
      if (this.value.clouza_company_code !== null && this.value.clouza_company_code !== '') {
        requestData.clouza_company_code = this.value.clouza_company_code
      }
      // タイムカード＋CLOUZA有休管理＋申請承認オプション
      if (this.value.paid_leave_option === true) {
        requestData.paid_leave_option = '1'
      }
      // ディスク増設 チェックボックス
      if (this.value.option_disk === true) {
        requestData.option_disk  = '1'
      }
      // ディスク増設容量
      if (this.value.option_disk_size !== null && this.value.option_disk_size !== '' && this.value.option_disk === true) {
        requestData.option_disk_size = this.value.option_disk_size
      }
      // Sync for smartphones
      if (this.value.option_sync === true) {
        requestData.option_sync = '1'
      }
      // Sync for smartphones ユーザ数
      if (this.value.option_sync_input !== null && this.value.option_sync_input !== '') {
        requestData.option_sync_input = this.value.option_sync_input
      }
      // desknet'sドライブ ディスク増設 チェックボックス
      if (this.value.option_dn_drive === true) {
        requestData.option_dn_drive  = '1'
      }
      // desknet'sドライブ ディスク増設容量
      if (this.value.option_dn_drive_disk_size !== null && this.value.option_dn_drive_disk_size !== '' && this.value.option_dn_drive === true) {
        requestData.option_dn_drive_disk_size = this.value.option_dn_drive_disk_size
      }
      // セキュリティオプション チェックボックス
      if (this.value.security_option === true) {
        requestData.security_option = '1'
      }
      // BASIC認証チェックボックス
      if (this.value.basic_auth === true) {
        requestData.basic_auth = '1'
      }
      // BASIC認証ユーザーID
      if (this.value.basic_auth_user !== null && this.value.basic_auth_user !== '') {
        requestData.basic_auth_user = this.value.basic_auth_user
      }
      // BASIC認証パスワード
      if (this.value.basic_auth_password !== null && this.value.basic_auth_password !== '') {
        requestData.basic_auth_password = this.value.basic_auth_password
      }
      // BASIC認証認証を除外するIPアドレス
      if (this.value.basic_auth_ip !== null && this.value.basic_auth_ip !== '') {
        requestData.basic_auth_ip = this.value.basic_auth_ip
      }
      // 接続を許可するIPアドレス チェックボックス
      if (this.value.ip_restrictions === true) {
        requestData.ip_restrictions = '1'
      }
      // 接続を許可するIPアドレス
      if (this.value.ip_restrictions_ip !== null && this.value.ip_restrictions_ip !== '') {
        requestData.ip_restrictions_ip = this.value.ip_restrictions_ip
      }
      // セキュアブラウザチェックボックス
      if (this.value.secure_browser === true) {
        requestData.secure_browser = '1'
      }
      // セキュアブラウザ端末認証
      if (this.value.secure_browser_terminal !== null && this.value.secure_browser_terminal !== '' && this.value.secure_browser === true) {
        requestData.secure_browser_terminal = this.value.secure_browser_terminal
      }
      // セキュアブラウザデバイス数
      if (this.value.secure_browser_terminal !== null && this.value.secure_browser_terminal !== '' && this.value.secure_browser === true) {
        requestData.secure_browser_device = this.value.secure_browser_device
      }
      // セキュアブラウザセキュアブラウザを適用しないIPアドレス
      if (this.value.secure_browser_ip !== null && this.value.secure_browser_ip !== '') {
        requestData.secure_browser_ip = this.value.secure_browser_ip
      }
      // クライアント認証チェックボックス
      if (this.value.client_auth === true) {
        requestData.client_auth = '1'
      }
      // クライアント認証デバイス数
      if (this.value.client_auth_input !== null && this.value.client_auth_input !== '') {
        requestData.client_auth_input = this.value.client_auth_input
      }
      // クライアント認証認証を除外するIPアドレス
      if (this.value.client_auth_ip !== null && this.value.client_auth_ip !== '') {
        requestData.client_auth_ip = this.value.client_auth_ip
      }
      // メールサービス チェックボックス
      if (this.value.mail_service === true) {
        requestData.mail_service = '1'
      }
      // WebARENA
      if (this.value.web_arena === true) {
        requestData.web_arena = '1'
      }
      // WebARENA利用ドメイン名
      if (this.value.web_arena_domain !== null && this.value.web_arena_domain !== '') {
        requestData.web_arena_domain = this.value.web_arena_domain
      }
      // WebARENAアカウント数
      if (this.value.web_arena_input !== null && this.value.web_arena_input !== '') {
        requestData.web_arena_input = this.value.web_arena_input
      }
      // CYBERMAILΣチェックボックス
      if (this.value.cyber === true) {
        requestData.cyber_check = '1'
      }
      // CYBERMAILΣアカウント数
      if (this.value.cyber_input !== null && this.value.cyber_input !== '') {
        requestData.cyber_input = this.value.cyber_input
      }
      // CYBERMAILΣメールボックス容量
      if (this.value.cyber_capacity !== null && this.value.cyber_capacity !== '' && this.value.cyber === true) {
        requestData.cyber_capacity = this.value.cyber_capacity
      }
      // CYBERMAILΣオプション
      // オプションが一つでも選択されている場合
      if (this.value.cyber_option.some((option) => option === true)) {
        // 配列を生成
        requestData.cyber_option = []

        // bool値をフラグ値に変換する
        if (this.value.cyber_option[0] === true) {
          requestData.cyber_option.push('00')
        }
        if (this.value.cyber_option[1] === true) {
          requestData.cyber_option.push('01')
        }
        if (this.value.cyber_option[2] === true) {
          requestData.cyber_option.push('02')
        }
        if (this.value.cyber_option[3] === true) {
          requestData.cyber_option.push('03')
        }
      }
      // CYBERMAILΣメールアーカイブ＆監査保存期間
      if (this.value.cyber_keep_period !== null && this.value.cyber_keep_period !== '' && this.value.cyber === true) {
        requestData.cyber_keep_period = this.value.cyber_keep_period
      }
      // メールセキュリティサービス チェックボックス
      if (this.value.mail_security_service === true) {
        requestData.mail_security_service = '1'
      }
      // MAILGATES Σチェックボックス
      if (this.value.mailgates === true) {
        requestData.mailgates_check = '1'
      }
      // MAILGATES Σ利用ドメイン名
      if (this.value.mailgates_domain !== null && this.value.mailgates_domain !== '') {
        requestData.mailgates_domain = this.value.mailgates_domain
      }
      // MAILGATES Σアカウント数
      if (this.value.mailgates_input !== null && this.value.mailgates_input !== '') {
        requestData.mailgates_input = this.value.mailgates_input
      }
      // MAILGATES Σオプション
      if (this.value.mailgates_option.some((option) => option === true)) {
        // 配列を生成
        requestData.mailgates_option = []

        // bool値をフラグ値に変換する
        if (this.value.mailgates_option[0] === true) {
          requestData.mailgates_option.push('01')
        }
        if (this.value.mailgates_option[1] === true) {
          requestData.mailgates_option.push('02')
        }
        if (this.value.mailgates_option[2] === true) {
          requestData.mailgates_option.push('03')
        }
      }
      // ご希望サブドメイン名
      if (this.value.sub_domain !== null && this.value.sub_domain !== '') {
        requestData.sub_domain = this.value.sub_domain
      }
      // 無料お試し版からのデータ移行チェックボックス
      if (this.value.migration === true) {
        requestData.migration = '1'
        // 無料お試し版からのデータ移行試使用環境URL
        if (this.value.migration_url !== null && this.value.migration_url !== '') {
          requestData.migration_url = this.value.migration_url
        }
        // 無料お試し版からのデータ移行作業日付
        // 無料お試し版からのデータ移行作業時刻（から）
        // 無料お試し版からのデータ移行作業時刻（まで）
        if (this.value.migration_date !== null && this.value.migration_date !== '') {
          requestData.migration_date = this.value.migration_date
          requestData.migration_time_from = this.value.migration_time_from
          requestData.migration_time_to = this.value.migration_time_to
        }
      }
      // ご利用開始希望日
      if (this.value.preferred_date !== null && this.value.preferred_date !== '') {
        requestData.preferred_date = this.value.preferred_date
      }
      // お見積番号
      if (this.value.estimate !== null && this.value.estimate !== '') {
        requestData.estimate = this.value.estimate
      }
      // 備考
      if (this.value.remarks !== null && this.value.remarks !== '') {
        requestData.remarks = this.value.remarks
      }
      // サービス利用約款などチェックボックス
      if (this.value.provision_check === true) {
        requestData.provision_check = '1'
      }

      return requestData
    },
    responseErrorMessage(target, msg) {
      // 現在のスクロール先インデックス
      let hashIndex = this.neoAnchorList.indexOf(this.errorHash)

      switch (target) {
        // プラン名
        case 'plan_name':
          this.error_msg_list.plan.error_msg.push(msg)
          this.errorHash = this.neoAnchorList[0]
          break
        // プランユーザー
        case 'plan_user':
          this.error_msg_list.plan.error_msg.push(msg)
          this.errorHash = this.neoAnchorList[0]
          break
        // 業務アプリ作成ツールAppSuite
        case 'app_suite_user':
          this.error_msg_list.app_suite.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 1 ? this.neoAnchorList[1] : this.errorHash
          break
        // desknet's ウェブ会議
        case 'web_conferencing':
          this.error_msg_list.web_conferencing.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.neoAnchorList[2] : this.errorHash
          break
        // オプションサービス チェックボックス
        case 'option_service':
          this.error_msg_list.option_service.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // RoomMgrチェックボックス
        case 'option_room_mgr':
          this.error_msg_list.option_room_mgr.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // 交通費・経費精算チェックボックス
        case 'option_expense_settlement':
          this.error_msg_list.option_expense_settlement.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // タイムカード＋CLOUZA
        case 'clouza_check':
          this.error_msg_list.clouza_check.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // タイムカード＋CLOUZAユーザー数
        case 'clouza_input':
          this.error_msg_list.clouza_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // タイムカード＋CLOUZA会社コード
        case 'clouza_company_code':
          this.error_msg_list.clouza_company_code.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        case 'paid_leave_option':
          this.error_msg_list.paid_leave_option.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // ディスク増設容量
        case 'option_disk_size':
          this.error_msg_list.option_disk_size.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // Sync for smartphones
        case 'option_sync':
          this.error_msg_list.option_sync.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // Sync for smartphones ユーザー数
        case 'option_sync_input':
          this.error_msg_list.option_sync_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // desknet'sドライブ ディスク増設容量
        case 'option_dn_drive_disk_size':
          this.error_msg_list.option_dn_drive_disk_size.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // BASIC認証チェックボックス
        case 'basic_auth':
          // this.basic_auth.description = msg
          break
        // BASIC認証ユーザーID
        case 'basic_auth_user':
          this.error_msg_list.basic_auth_user.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // BASIC認証パスワード
        case 'basic_auth_password':
          this.error_msg_list.basic_auth_password.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // BASIC認証認証を除外するIPアドレス
        case 'basic_auth_ip':
          this.error_msg_list.basic_auth_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 接続を許可するIPアドレス チェックボックス
        case 'ip_restrictions':
          break
        // 接続を許可するIPアドレス
        case 'ip_restrictions_ip':
          this.error_msg_list.ip_restrictions_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // セキュアブラウザチェックボックス
        case 'secure_browser':
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // セキュアブラウザ端末認証
        case 'secure_browser_terminal':
          this.error_msg_list.secure_browser_terminal.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // セキュアブラウザデバイス数
        case 'secure_browser_device':
          this.error_msg_list.secure_browser_device.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        case 'secure_browser_ip':
          this.error_msg_list.secure_browser_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // クライアント認証チェックボックス
        case 'client_auth':
          this.error_msg_list.client_auth.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // クライアント認証デバイス数
        case 'client_auth_input':
          this.error_msg_list.client_auth_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // クライアント認証認証を除外するIPアドレス
        case 'client_auth_ip':
          this.error_msg_list.client_auth_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // メールサービス チェックボックス
        case 'mail_service':
          break
        // WebARENA
        case 'web_arena':
          this.error_msg_list.web_arena.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // WebARENA利用ドメイン名
        case 'web_arena_domain':
          this.error_msg_list.web_arena_domain.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // WebARENAアカウント数
        case 'web_arena_input':
          this.error_msg_list.web_arena_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // CYBERMAILΣチェックボックス
        case 'cyber':
          this.error_msg_list.cyber.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // CYBERMAILΣアカウント数
        case 'cyber_input':
          this.error_msg_list.cyber_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // CYBERMAILΣメールボックス容量
        case 'cyber_capacity':
          this.error_msg_list.cyber_capacity.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // CYBERMAILΣオプション
        case 'cyber_option':
          this.error_msg_list.cyber_option.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // CYBERMAILΣメールアーカイブ＆監査保存期間
        case 'cyber_keep_period':
          this.error_msg_list.cyber_keep_period.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // メールセキュリティサービス チェックボックス
        case 'mail_service':
          break
        // MAILGATES Σチェックボックス
        case 'mailgates':
          this.error_msg_list.mailgates.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // MAILGATES Σチェックボックス
        case 'mailgates_domain':
          this.error_msg_list.mailgates_domain.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // MAILGATES Σチェックボックス
        case 'mailgates_input':
          this.error_msg_list.mailgates_input.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // MAILGATES Σオプション
        case 'mailgates_option':
          this.error_msg_list.mailgates_option.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // ご希望サブドメイン名
        case 'sub_domain':
          this.error_msg_list.sub_domain.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 6 ? this.neoAnchorList[6] : this.errorHash
          break
        // 無料お試し版からのデータ移行チェックボックス
        case 'migration':
          this.error_msg_list.migration.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.neoAnchorList[8] : this.errorHash
          break
        // 無料お試し版からのデータ移行試使用環境URL
        case 'migration_url':
          this.error_msg_list.migration_url.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.neoAnchorList[8] : this.errorHash
          break
        // 無料お試し版からのデータ移行作業日付
        case 'migration_date':
          this.error_msg_list.migration_datetime.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.neoAnchorList[8] : this.errorHash
          break
        // 無料お試し版からのデータ移行作業時刻（から）
        case 'migration_time_from':
          this.error_msg_list.migration_datetime.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.neoAnchorList[8] : this.errorHash
          break
        // 無料お試し版からのデータ移行作業時刻（まで）
        case 'migration_time_to':
          this.error_msg_list.migration_datetime.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.neoAnchorList[8] : this.errorHash
          break
        // ご利用開始希望日
        case 'preferred_date':
          this.error_msg_list.preferred_date.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 9 ? this.neoAnchorList[9] : this.errorHash
          break
        // お見積番号
        case 'estimate':
          this.error_msg_list.estimate.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 7 ? this.neoAnchorList[7] : this.errorHash
          break
        // 備考
        case 'remarks':
          this.error_msg_list.remarks.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 10 ? this.neoAnchorList[10] : this.errorHash
          break
        // サービス利用約款などチェックボックス
        case 'provision_check':
          this.error_msg_list.provision_check.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 11 ? this.neoAnchorList[11] : this.errorHash
          break
        // desknet'sNEO組み合わせの該当箇所にエラーメッセージを追加
        // 「スタンダードプラン」 + 「AppSuite」
        case 'appsuite_standard':
          this.error_msg_list.plan.error_msg.push(msg)
          this.error_msg_list.app_suite.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[0] : this.errorHash
          break
        // 「タイムカード＋CLOUZA」 ＋ 「セキュアブラウザ」
        case 'clouza_secure':
          this.error_msg_list.clouza_check.error_msg.push(msg)
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[3] : this.errorHash
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'basic_except_permit':
          this.error_msg_list.basic_auth.error_msg.push(msg)
          this.error_msg_list.ip_restrictions.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「BASIC認証」 ＋ 「クライアント認証」
        case 'basic_client':
          this.error_msg_list.basic_auth.error_msg.push(msg)
          this.error_msg_list.client_auth.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「BASIC認証」 ＋ 「セキュアブラウザ」の「端末認証あり」
        case 'basic_secure_device':
          this.error_msg_list.basic_auth.error_msg.push(msg)
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「セキュアブラウザ」の「端末認証なし」
        case 'basic_except_secure_terminal':
          this.error_msg_list.basic_auth_ip.error_msg.push(msg)
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「接続元IPアドレス制限」 ＋ 「クライアント認証」
        case 'permit_client':
          this.error_msg_list.ip_restrictions.error_msg.push(msg)
          this.error_msg_list.client_auth.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「接続元IPアドレス制限」 ＋ 「セキュアブラウザ」
        case 'permit_secure':
          this.error_msg_list.ip_restrictions.error_msg.push(msg)
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // 「クライアント認証」 ＋ 「セキュアブラウザ」
        case 'client_secure':
          this.error_msg_list.client_auth.error_msg.push(msg)
          this.error_msg_list.secure_browser.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.neoAnchorList[4] : this.errorHash
          break
        // CYBERMAILの「情報漏えい対策（有償）」+「添付ファイル暗号化・分離（有償）」
        case 'cyber_leak_encode':
          this.error_msg_list.cyber_option.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // 「CYBERMAILΣ」　＋ 「MAILGATES Σ」
        case 'cyber_mailgates':
          this.error_msg_list.cyber.error_msg.push(msg)
          this.error_msg_list.mailgates.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        // 「MAILGATES Σ」の「誤送信対策・審査」 ＋ 「MAILGATES Σ」の「添付ファイル暗号化・分離」
        case 'prevent_missend_separation':
          this.error_msg_list.mailgates_option.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.neoAnchorList[5] : this.errorHash
          break
        default:
          break
      }
    },
    /**
     * エラー表示をリセットする
     */
    resetError () {
      // 全てのエラーメッセージ要素を空にする
      this.error_msg_list.upper_part_error.error_msg = []          // 画面上部のエラーメッセージ
      this.error_msg_list.plan.error_msg = []                      // プラン
      this.error_msg_list.app_suite.error_msg = []                 // 業務アプリ作成ツールAppSuite
      this.error_msg_list.web_conferencing.error_msg = []          // desknet's ウェブ会議

      this.error_msg_list.option_service.error_msg = []            // オプションサービスチェックボックス
      this.error_msg_list.option_expense_settlement.error_msg = [] // 交通費・経費精算チェックボックス
      this.error_msg_list.clouza_check.error_msg = []              // タイムカード＋CLOUZAチェックボックス
      this.error_msg_list.clouza_input.error_msg = []              // タイムカード＋CLOUZAユーザー数
      this.error_msg_list.clouza_company_code.error_msg = []       // タイムカード＋CLOUZA会社コード
      this.error_msg_list.paid_leave_option.error_msg = []         // タイムカード＋CLOUZA有休管理＋申請承認オプション
      this.error_msg_list.option_disk_size.error_msg = []          // ディスク増設容量
      this.error_msg_list.option_sync.error_msg = []               // Sync for smartphoneチェックボックス
      this.error_msg_list.option_sync_input.error_msg = []         // Sync for smartphoneユーザー数
      this.error_msg_list.option_dn_drive_disk_size.error_msg = [] // desknet'sドライブ ディスク増設容量

      this.error_msg_list.security_option.error_msg = []         // セキュリティオプションチェックボックス
      this.error_msg_list.basic_auth.error_msg = []              // BASIC認証チェックボックス
      this.error_msg_list.basic_auth_user.error_msg = []         // BASIC認証ユーザーID
      this.error_msg_list.basic_auth_password.error_msg = []     // BASIC認証パスワード
      this.error_msg_list.basic_auth_ip.error_msg = []           // BASIC認証認証を除外するIPアドレス
      this.error_msg_list.ip_restrictions.error_msg = []         // 接続元IPアドレス制限チェックボックス
      this.error_msg_list.ip_restrictions_ip.error_msg = []      // 接続元IPアドレス制限接続を許可するIPアドレス
      this.error_msg_list.secure_browser.error_msg = []          // セキュアブラウザチェックボックス
      this.error_msg_list.secure_browser_terminal.error_msg = [] // セキュアブラウザ端末認証
      this.error_msg_list.secure_browser_device.error_msg = []   // セキュアブラウザデバイス数
      this.error_msg_list.secure_browser_ip.error_msg = []       // セキュアブラウザセキュアブラウザを適用しないIPアドレス
      this.error_msg_list.client_auth.error_msg = []             // クライアント認証チェックボックス
      this.error_msg_list.client_auth_input.error_msg = []       // クライアント認証デバイス数
      this.error_msg_list.client_auth_ip.error_msg = []          // クライアント認証認証を除外するIPアドレス

      this.error_msg_list.mail_service.error_msg = []      // メールサービスチェックボックス
      this.error_msg_list.web_arena.error_msg = []         // WebARENA
      this.error_msg_list.web_arena_domain.error_msg = []  // WebARENA利用ドメイン名
      this.error_msg_list.web_arena_input.error_msg = []   // WebARENAアカウント数
      this.error_msg_list.cyber.error_msg = []             // CYBERMAILΣチェックボックス
      this.error_msg_list.cyber_input.error_msg = []       // CYBERMAILΣアカウント数
      this.error_msg_list.cyber_capacity.error_msg = []    // CYBERMAILΣメールボックス容量
      this.error_msg_list.cyber_option.error_msg = []      // CYBERMAILΣオプション
      this.error_msg_list.cyber_keep_period.error_msg = [] // CYBERMAILΣ保存期間

      this.error_msg_list.mail_security_service.error_msg = [] // メールサービスチェックボックス
      this.error_msg_list.mailgates.error_msg = []             // MAILGATES Σチェックボックス
      this.error_msg_list.mailgates_domain.error_msg = []      // MAILGATES Σ利用ドメイン名
      this.error_msg_list.mailgates_input.error_msg = []       // MAILGATES Σアカウント数
      this.error_msg_list.mailgates_option.error_msg = []      // MAILGATES Σオプション

      this.error_msg_list.sub_domain.error_msg = []    // ご希望サブドメイン名
      this.error_msg_list.estimate.error_msg = []      // お見積番号
      this.error_msg_list.migration.error_msg = []     // 無料お試し版からのデータ移行チェックボックス
      this.error_msg_list.migration_url.error_msg = [] // 無料お試し版からのデータ移行試使用環境URL

      // 無料お試し版からのデータ移行作業日付
      // 無料お試し版からのデータ移行作業時刻（から）
      // 無料お試し版からのデータ移行作業時刻（まで）
      this.error_msg_list.migration_datetime.error_msg = []

      this.error_msg_list.preferred_date.error_msg = []  // ご利用開始希望日
      this.error_msg_list.remarks.error_msg = []         // 備考
      this.error_msg_list.provision_check.error_msg = [] // サービス利用約款などチェックボックス
      this.errorHash = ''                                // エラー発生時のスクロール先を初期化する
    },
    toggleNextButtonDisabled() {
      this.nextButtonDisabled = !this.nextButtonDisabled;
    }
  },
}
</script>

<style scoped>
.card-width {
  width: 721px;
}
.next-icon {
  margin-top: 2px;
}
.image-size {
  width: 200px;
  height: 150px;
}
</style>